import React, {  useEffect, useRef, } from "react";
import { get, } from "lodash";
import cx from "classnames";
import styles from "./styles.module.scss";
import Actions from "src/components/actionbar";
import { SyncScrollLayout } from "../syncScrollLayout";
import { Account } from "src/types/accounts";
import Button from "src/components/button";
import { useTinyMce } from "src/components/useTinyMce";

type EmailViewerProps = {
  data: Account | {};
  handleChange?: (field: string, value: any) => void;
  showEditor: boolean;
  toggleEditor: () => void;
}

export const EmailViewer = ({
   data,
   handleChange,
   showEditor,
   toggleEditor,
}: EmailViewerProps) => {
   
  const initialEmailBodyRef = useRef( get(data, "librarySettings.reshareEmail") ?? ""); // Initial email body

  const {Renderer: EmailBodyViewer , TinyMce: EmailBodyEditor , output: updatedEmailBody,} = useTinyMce(initialEmailBodyRef.current ?? '');
  
  useEffect(() => { // change handler for email body
     handleChange?.("librarySettings.reshareEmail", updatedEmailBody);
  }, [updatedEmailBody])


  // configuration
  const viewerConfiguration = [
       {
         component:  <ViewerRenderer emailBody={< EmailBodyViewer />} />,
       }
  ];
  
  const editorConfiguration = [
      {
         component: <EditorRenderer 
            bodyEditor={<EmailBodyEditor 
                        classnames={styles.editor}  
                        plugins = 'code noneditable, variable, widget,  autolink, link, textcolor, lists, paste'
                        toolbar = 'bold italic | alignleft aligncenter alignright | numlist bullist | fontselect | fontsizeselect | forecolor backcolor | link'
                        transparentBackground={true}
                        />} 
         />
      }  
  ];

    return (
     <div className={styles.container}>
            <Actions.IconButton
                  icon={"paperflite-up-arrow"}
                  className={cx(styles.previewAction, { [styles.hide]: showEditor })}
                  onClick={() => {
                    toggleEditor();
                  }}
            />
                       
            <SyncScrollLayout 
                  viewerRenderer={viewerConfiguration}
                  editorRenderer={editorConfiguration}  
                  showEditor={showEditor}
                  animateEditorScroll={false}
                  animateViewerScroll={false}
            />
    </div>
    );
}

export const ViewerRenderer = ({emailBody}: {emailBody: React.ReactNode}) => {
  return(
    <div className={styles.rendererContainer}>       
                       <div className={styles.preview}>
                             <div className={styles.compose}>
                               <div className={cx(styles.pointerEventNone, styles.flexShrink_0)}>
                                  <p className={styles.title}> Compose</p>
                                  <p className={styles.subTitle}>quick send</p>
                               </div>
                               <div className={cx(styles.innerContainer, styles.pointerEventNone, styles.flexShrink_0)}>
                                     <div className={styles.input}>
                                             <p className={styles.preText}>To</p>
                                     </div>
                                      <div className={styles.input}>
                                             <p className={styles.preText}>Subject</p>
                                     </div>
                               </div>
                               <div className={styles.emailBody}>
                                <div className={styles.restrictEvents}>{emailBody}</div>
                               </div>
                               <div className={cx(styles.actionButtons, styles.pointerEventNone, styles.flexShrink_0)}>
                                <Button
                                  variant="primary"
                                  icon="paperflite-send"
                                  text="Send"
                                  disabled={true}
                                  onClick={()=>{}}
                                  className={styles.btn}
                                />
                                <Button
                                  variant="secondary"
                                  text="Cancel"
                                  onClick={()=>{}}
                                   className={styles.btn}
                                />  
                               </div>
                             </div>
                       </div>
                       <div className={cx(styles.editor, styles.pointerEventNone)}>
                          <p className={styles.title}>assets</p>
                          <div className={styles.assetsContainer}>
                              <div className={styles.assetItem}>
                                  <span className={styles.tag}>
                                     PDF
                                  </span>
                              </div>
                              
                               <div className={styles.assetItem}>
                                  <span className={styles.tag}>
                                     PDF
                                  </span>
                              </div>
                          </div>
                       </div>
               
    </div>
  )
}

export const EditorRenderer = ({bodyEditor}: {bodyEditor:  React.ReactNode}) => {
    return (
    <div className={styles.editorRendersContainer}>
        <div className={styles.header}>
                <h5 className={styles.title}>Email Content Customization</h5>
                <p className={styles.subText}>Customize the content that goes into the body and footer of your email.</p>
        </div>

        <div className={styles.innerContainer}>
            <p className={styles.title}>Email Content</p>
            {bodyEditor}
        </div>
    </div>
    )
}
